import React, { useState } from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "../components/Reveal";
import { sendContact } from "../lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await sendContact(form);
      toast.success(res.message);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-transparent border-b border-forest/20 py-3 text-forest placeholder-forest-soft/60 focus:outline-none focus:border-terracotta";

  return (
    <div className="pt-32 md:pt-40">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-16">
        <div className="md:col-span-5">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] text-terracotta mb-6">Contact</p>
            <h1 className="font-serif text-5xl md:text-7xl text-forest tracking-tight leading-[0.95] mb-8">
              Say <span className="italic text-sage">hello</span>.
            </h1>
            <p className="text-forest-soft text-lg leading-relaxed mb-10 max-w-sm">
              Questions, custom blend requests, or wholesale inquiries — we&rsquo;d love to hear from you.
            </p>
            <ul className="space-y-5 text-forest">
              <li className="flex items-center gap-3"><span className="w-10 h-10 rounded-full bg-surface flex items-center justify-center"><Phone className="w-4 h-4 text-terracotta" /></span> (262) 945-6334</li>
              <li className="flex items-center gap-3"><span className="w-10 h-10 rounded-full bg-surface flex items-center justify-center"><Mail className="w-4 h-4 text-terracotta" /></span> gingerroehl29@gmail.com</li>
              <li className="flex items-center gap-3"><span className="w-10 h-10 rounded-full bg-surface flex items-center justify-center"><MapPin className="w-4 h-4 text-terracotta" /></span> Racine, Wisconsin</li>
            </ul>
          </Reveal>
        </div>

        <div className="md:col-span-6 md:col-start-7">
          <Reveal delay={0.15}>
            <form onSubmit={submit} className="space-y-8 rounded-[2.5rem] bg-surface p-8 md:p-12" data-testid="contact-form">
              <div>
                <label className="text-xs uppercase tracking-widest text-forest-soft">Name</label>
                <input required value={form.name} onChange={set("name")} className={field} placeholder="Your name" data-testid="contact-name" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-widest text-forest-soft">Email</label>
                <input required type="email" value={form.email} onChange={set("email")} className={field} placeholder="you@email.com" data-testid="contact-email" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-widest text-forest-soft">Subject</label>
                <input value={form.subject} onChange={set("subject")} className={field} placeholder="Custom blend request…" data-testid="contact-subject" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-widest text-forest-soft">Message</label>
                <textarea required rows={4} value={form.message} onChange={set("message")} className={`${field} resize-none`} placeholder="Tell us the feeling you’re after…" data-testid="contact-message" />
              </div>
              <button type="submit" disabled={loading} data-testid="contact-submit" className="w-full rounded-full bg-forest hover:bg-terracotta text-cream py-4 text-sm uppercase tracking-widest font-semibold disabled:opacity-60" style={{ transition: "background-color 0.3s ease" }}>
                {loading ? "Sending…" : "Send Message"}
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
